import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { isCompany } from '../../Config/isCompany';
import { isUser } from '../../Config/isUser';

const UserPostCard = ({ post }) => {
  const [company, setCompany] = useState({})
  useEffect(() => {
    const fetchCompany = async () => {
      if (post.company_id) {
        try {
          const response = await axios.post(
            "https://kariyer.biyomed.net/api/companies/getOneDetailsCard",
            { company_id: post.company_id }, // `post` propsunu company_id olarak gönderiyoruz
            { withCredentials: true }
          );
          setCompany(response.data.company);
        } catch (error) {
          console.error("Error fetching company details:", error);
        }
      }

    };

    if (post) {
      fetchCompany(); // `post` değeri varsa istek yapılır
    }
  }, [post]); // `post` değiştiğinde yeniden çağırır

  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleClick = (e, id, link, website) => {
    e.preventDefault();
    if (id) {
      window.location.href = `companyinfo/${id}`
    }
    else {
      const correctedWebsite =
        website?.startsWith("http://") || website?.startsWith("https://")
          ? website
          : `https://${website}`;
      window.location.href = website ? correctedWebsite : link;
    }

  }

  return (
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div className="jp_job_post_main_wrapper_cont jp_job_post_grid_main_wrapper_cont">
        <div className="jp_job_post_main_wrapper jp_job_post_grid_main_wrapper">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_job_post_side_img">
                <img style={{ marginLeft: 25, marginTop: 25, maxHeight: 70, maxWidth: 100 }}
                  src={
                    company?.profile_image
                      ? company.profile_image
                      : post?.image && post.image.startsWith("https://")
                        ? post.image
                        : "https://pbs.twimg.com/profile_images/1305064450848960525/gsJVVM41_400x400.jpg"
                  }
                  alt="post_img"
                />
              </div>
              <div className="jp_job_post_right_cont jp_job_post_grid_right_cont">
                <h4 style={{ fontSize: post.position_name?.length > 35 ? '13px' : '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {post.position_name}
                </h4>


                <p
                  onClick={(e) => handleClick(e, post.company_id, post.job_link, post.website)}
                  onMouseEnter={(e) => (e.target.style.color = "black")}
                  onMouseLeave={(e) => (e.target.style.color = "#23c0e9")}
                  style={{
                    fontSize: "14px",
                    marginTop: 10,
                    cursor: "pointer",
                    color: "#23c0e9", // Varsayılan renk
                    transition: "color 0.2s ease-in-out", // Yumuşak geçiş efekti
                    fontSize: post.company_name.length > 30 ? '12px' : '16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                  }}
                >
                  {post.company_name}
                </p>

                <ul>
                  <li>
                    <i className="fa fa-map-marker" />
                    &nbsp;
                    {post.city && post.city.split(',').length > 2 ? (
                      <>
                        {post.city.split(',').slice(0, 2).join(', ')}...
                        <span style={{ color: '#23c0e9' }}>+{post.city.split(',').length - 2} daha  </span>
                      </>
                    ) : (
                      post.city
                    )}
                  </li>

                  <li style={{ fontSize: '14px', marginTop: 3 }}>
                    <i className="fa fa-calendar" />
                    &nbsp; Yayımlama Tarihi: {formattedDate}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_job_post_right_btn_wrapper jp_job_post_grid_right_btn_wrapper">
                <ul style={{ marginTop: 40 }}>
                  <li >

                  </li>
                  <li>
                    <a
                      style={{ marginLeft: 120 }}
                      href={post.full_name ? (isUser || isCompany ? `/apply-fast-post/${post.id}` : '/login') : (post.company_id ? (isUser || isCompany ? `/apply-post/${post.id}` : '/login') : post.job_link)}
                      target={post.company_id ? "_self" : "_blank"}
                      rel={post.company_id ? "" : "noopener noreferrer"}
                    >
                      İncele
                    </a>
                  </li>
                  <li>
                    <a onClick={(e) => e.preventDefault()} style={{ backgroundColor: post?.job_type === "Is" ? '#4cc4ff' : '#f7b248' }} href="/">
                      {post?.job_type === "Is" ? "İş İlanı" : post?.job_type === "Staj" ? "Staj İlanı" : post?.job_type}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="jp_job_post_keyword_wrapper">
          <ul>
            <li>
              <i className="fa fa-tags" />
              Kategori :
            </li>
            <li>
              <a
                href="/"
              >
                {post.position_category ? post.position_category.length > 35 ? post.position_category.slice(0, 35) + "..." : post.position_category : "Dış ilan"}
              </a>

            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default UserPostCard